import { render, staticRenderFns } from "./ThreeDScan.vue?vue&type=template&id=079b3d77&scoped=true"
import script from "./ThreeDScan.vue?vue&type=script&lang=ts"
export * from "./ThreeDScan.vue?vue&type=script&lang=ts"
import style0 from "./ThreeDScan.vue?vue&type=style&index=0&id=079b3d77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b3d77",
  null
  
)

export default component.exports